import { render, staticRenderFns } from "./PurchasingDetails.template.vue?vue&type=template&id=0d9e2254&scoped=true&"
var script = {}
import style0 from "./PurchasingDetails.template.vue?vue&type=style&index=0&id=0d9e2254&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e2254",
  null
  
)

export default component.exports